import * as Yup from 'yup';
import { emailValidation, verificationCodeValidation } from '../../helpers';

export const validationSchema = Yup.object().shape({
  email: emailValidation(),
  verificationCode: verificationCodeValidation(),
});
